const keys = {

	/*base_url*/
	SUCCESS : "success",
	ERROR : "error",
	WARNING : "warning",

	MAX_FILE_SIZE:4,
	PAGE_LENGTH:25,
	PAGE_LENGTH_10:10,
	ACCEPTED_IMAGE_FORMATE:['image/jpeg','image/png','image/jpg','application/pdf'],

	
	/* user type	*/
	WHOLESALER:'Wholesaler',
	WAREHOUSE:'Warehouse Agent',
	SUPER_ADMIN:'SuperAdmin',

	/* Agent type */
	PICKUP_AGENT:"Pickup Agent",
	DELIVERY_AGENT:"Delivery Agent",
	WAREHOUSE_AGENT:"Warehouse Agent",


	// deactive
	WS_ACTIVE:"active",
	WS_DEACTIVE:"deactive",


	/*shipment status Keys*/ 
	CONFIRMATION_PENDING:"Confirmation Pending",
	CONFIRMED:"Confirmed",
	PICKED_UP:"Picked up",
	DROPPED_AT_WAREHOUSE:"Dropped at Warehouse",
	DROPPED_AT_WAREHOUSE_RETURN:"Dropped at Warehouse Return",
	OUT_FOR_DELIVERY:"Out for Delivery",
	DELIVERED:"Delivered",
	ON_HOLD:"On Hold",
	RETURN:"Return",
	PARTIAL_RETURN:"Partial Return",
	WITHDRAWN:"Withdrawn",
	CANCELLED:"Cancelled",

	COLLECTED:"Collected",
	DELIVERED_WITH_CREDIT:"Delivered with Credit",


	ACTIVE:"ACTIVE",
	INACTIVE:"INACTIVE",
	CURRENT:"CURRENT",

	/* support ticket  status*/
	OPEN:"Open", 
	CLOSE:"Close", 
	CLOSED:"Closed", 

	/*key for the  return and collections*/
	RETURNS:"RETURNS",
	COLLECTION:"COLLECTION",

	/* keys for empty state type*/ 
	EMPTY_TYPE_1:"type_1",
	EMPTY_TYPE_2:"type_2",

	/* Bollean */ 
	TRUE:"True",
	FALSE:"False",

	SHIPMENT_COLLECTION:"Collection",
	SHIPMENT_RETURNS:"Returns",


	SUCCESSFUL:"Successful",
	FAILED:"Failed",
	INITIATED:"Initiated",
	OPTION_NEFT:"NEFT/IMPS",
	OPTION_PAYTM:"Paytm",
	OPTION_CHEQUE:"Cheque",

	/* subscripiption plan type */ 
	REGULAR_PLAN: "Regular",
	ADDON_PLAN: "Add-on",
	SPECIAL_PLAN: "Special",

	/* retailer type options */
	DUMMY_RETAILER:"Dummy", 
	REGISTERED_RETAILER:"Registered", 
	UNREGISTERED_RETAILER:"Unregistered", 


	/* Google places keys */ 
	// GOOGLE_PLACES_API_KEY:"AIzaSyCDH55Mm8htXHkK2e7AefN5ReelwcA9WrU",
	// medx
	GOOGLE_PLACES_API_KEY:"AIzaSyDK-L_2b2D7o9NQcpN7iRrSv7o4UXv1P0M",

	MIN_BALANCE_AMOUNT:1000,
	// staging
	STAGING_PAYTM_MID:"MedXPr36752513830547",
	STAGING_PAYTM_PG_URL:"https://securegw-stage.paytm.in/theia/api/v1/showPaymentPage",

	// prod
	PRODUCTION_PAYTM_MID:"MedXPr11102788811467",
	PRODUCTION_PAYTM_PG_URL:"https://securegw.paytm.in/theia/api/v1/showPaymentPage",
	



};
export default keys;	
